<template>
    <div class="full height">
        <Authentication/>
        <div
            v-if="$auth.isAuthenticated()"
            class="full width"
        >
            <DeviceList/>
            <ReportView/>
        </div>
    </div>

</template>

<script>
    import { default as Authentication } from './Authentication';
    import { default as DeviceList } from './DeviceList';
    import { default as ReportView } from './ReportView';
    import { default as DeviceData } from './DeviceData';

    export default {
        name: 'MainView',
        components: { Authentication, DeviceList, ReportView, DeviceData}
    }
</script>

<style>
    .sidebar {
        background: dimgray;
        border-right: 1px solid #4d4d4c;
        width: 225px;
        min-width: 225px;
        flex: 0!important;
    }
    .full.height {
        display: flex;
        flex-direction: column;
        min-height: 100%;
    }
    .full.height>div {
        flex: 1;
        height: 100%;
    }
    .full.width {
        flex: 1;
        display: flex;
        flex-direction:row;
    }
    .full.width>div {
        flex: 1
    }
    h2 {
        color: white;
        font-size: 1.7em;
    }
     .dt-buttons {
         display: none!important;
     }
     .dataTables_length {
         display: none!important;
     }
</style>



// WEBPACK FOOTER //
// src/app/Main/components/MainView.vue